class Deficiency {
  constructor(element, name, macro, units) {
    this.element = element;
    this.name = name;
    this.macro = macro;
    this.units = units;
  }
}

export default Deficiency;
